import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import {
  getIsAppBundle,
  getIsPostPageBundle,
  SECTION_CATEGORY,
} from '@wix/communities-blog-client-common';
import { OOI_EXPERIMENTS } from '@app/experiments';
import { TooltipPortalProvider } from '../../context/tooltip-context';
import { getSection } from '../../selectors/section-selectors';
import AppWrapper from '../app-wrapper';
import { useSelector } from '../runtime-context';
import { type AppProps } from './app-props';
import styles from './app.scss';

type PropsDesktop = {
  desktopHeader?: React.FunctionComponentElement<{ menu?: React.FunctionComponentElement<any> }>;
};

const AppDesktop: React.FC<AppProps & PropsDesktop> = ({
  className,
  desktopHeader,
  main,
  messageRoot,
  modalRoot,
  popoverRoot,
}) => {
  const { isEditor, isPreview } = useEnvironment();
  const { experiments } = useExperiments();
  const isPostPageBundle = useSelector(getIsPostPageBundle);
  const isFeedPageBundle = useSelector(getIsAppBundle);
  const section = useSelector(getSection);
  const isCategorySection = section === SECTION_CATEGORY;

  useEffect(() => {
    if (!isEditor || isPreview) {
      document.documentElement.classList.add('enable-scroll');
    }
  }, [isPreview, isEditor]);

  const blogBackgroundColorClassName =
    isFeedPageBundle && isCategorySection
      ? 'blog-background-category-color'
      : 'blog-background-color';

  return (
    <AppWrapper
      className={
        isPostPageBundle && experiments.enabled(OOI_EXPERIMENTS.USE_NEW_POST_PAGE_SETTINGS_URL)
          ? classNames(className, styles.app, styles.postPageV2Root)
          : classNames(
              className,
              styles.app,
              blogBackgroundColorClassName,
              isPostPageBundle && styles.postPageApp,
            )
      }
    >
      <TooltipPortalProvider>
        {messageRoot}
        {modalRoot}
        {popoverRoot}
        <div id="content-wrapper">
          {desktopHeader}
          {main}
        </div>
      </TooltipPortalProvider>
    </AppWrapper>
  );
};

export default AppDesktop;
